import React, { useEffect, useRef, useState } from "react";
import {
    BsChatText,
    BsShare,
    BsPersonPlus,
    BsPersonFillCheck,
} from "react-icons/bs";
import { FaEllipsisH, FaAngleDown  } from "react-icons/fa";
import Button from "components/button/button";
import { Link, useHistory } from "react-router-dom";
import { FiSettings, FiLink } from "react-icons/fi";
import { IoLanguageOutline } from "react-icons/io5";
import { urlSerializer } from "utils/utils";
import _ from "lodash";
import Popup from "reactjs-popup";
import SocialsModal from "./share/socials";
import { useDialogHook } from "utils/customhooks";
import LoadingIndicator from "assets/svg/loading-indicator";
import { copyTextToClipboard } from "utils/utils";
import { PiWarningOctagonLight } from "react-icons/pi";
import ToolTip from "components/tootltip/tootltip";
import styled from "styled-components";
import Favicon from "components/fav-icon/Favicon";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import { social } from "utils/constant";

/**
 * this is for caching purposes.
 * base on the observation whenever user scrolls, it triggers and show the sticky component
 * it shows the component and calls getSocialMedia whenever it's visible (many times)
 * and it cause "too many request" error
 * this caching reduces the request/making it request only once
 */
const socialRequestCache = {};

export default function ProfileModal({
    userData = {},
    profile = {},
    hasPermission,
    isYourProfile,
    viewPublic,
    onClickMessage = () => {},
    onReport = () => {},
    showSocialMedia = true,
    isSticky = false,
    handleUpdateTranslate = () => {},
    fetchSocMed=null,
    setProfile=()=>{},
    displayTooltip = false
}) {
    const [loadingTranslate , setTransLoad] = useState(false);
    const { t, } = useTranslation();
    const { http } = global.services;
    const history = useHistory();
    const shareRef = useRef();
    const [open, setOpen] = useState(false);
    const [socials, setSocials] = useState([]);
    const [follow, setFollow] = useState(0);
    const shareModal = useDialogHook(SocialsModal);
    const [showMoreOption, setShowMoreOption] = useState();
    const [state, setState] = useState({
        profileUrl: "",
    });
    const [submitLoading, setSubmitLoading] = useState(true);
    const optionRef = useRef();
    const buttonRef = useRef(null);
    const [tooltipPos, setTooltipPos] = useState({ top: 0, left: 0 });

    const { user } = profile;
    let checkRerported = null;
    if (!_.isEmpty(user?.reports))
        checkRerported = user?.reports.find(
            (report) => report.user_id === userData?.user?.id
        );

    const getSocialMedia = async (data) => {
        let socialMedia = [];
        try {
            // key/ID of the cache
            // const cacheKey = `${profile?.id}-${userData?.profile?.id}`
            // console.log('socialCache: ', socialCache); 

            // if(socialRequestCache[cacheKey]) {
            //     // get the data from cache object
            //     data = socialRequestCache[cacheKey];
            // } else {
                // if no cache found then request it
                // const { data: result } = await http.get("public/social-medias", {
                //     user_profile_id: profile?.id,
                //     user_id: userData?.profile?.id,
                // });
                // data = result;
            // }

            const { social_media =[], follow={} } = data || {};


            if (follow) {
                setFollow(follow?.status);
            }
            if (social_media.length > 0) {
                social_media.forEach((sm) => {
                    if (sm.media_type === "social") {
                        socialMedia.push({
                            type: sm.type,
                            link: sm.link,
                            fav_icon: sm?.fav_icon?.url || null,
                            media_type: "social",
                            order: sm?.order || 0
                        });
                    }
                });
                setSocials(socialMedia.sort((a,b)=> a.order - b.order));
            }

            
            // if(!socialRequestCache[cacheKey]) {
            //     socialRequestCache[cacheKey] = data;
            // }
        } catch (err) {
            console.log("getPosition", err);
        }
        setSubmitLoading(false);
    };

  const handleCopyClick = (copyText) => {
    copyTextToClipboard(copyText).then(() => {
      toast.success("Copied to clipboard");
      setShowMoreOption(false);
    });
  };

    const showMoreSocial = () => {
        shareModal(
            {
                url: state.profileUrl,
                image: profile.profile_image_url,
                title: profile.profile_name,
                description: "Milestones Page - Your Creative History In One Place",
            },
            (callBack) => {
                console.log("showMoreSocial callback", callBack);
            }
        );
    };

    const onFollow = async () => {
        setSubmitLoading(true);
        const url = urlSerializer("/follow", {
            followed_id: profile?.id,
            follower_id: userData?.profile?.id,
        });
        const { data } = await http.post(url);
        const { follow } = data;
        setFollow(follow?.status);
        setSubmitLoading(false);
    };

    useEffect(() => {
        setSocials([])
        if (profile?.id) { 
            getSocialMedia(fetchSocMed); 
            let url = `${process.env.REACT_APP_PUBLIC_DOMAIN}/share/${profile.user.username}/profile/${profile.id}`;
            setState((prev) => ({
                ...prev,
                profileUrl: url,
            }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [profile,fetchSocMed]);

    useEffect(() => {
        window.addEventListener(
            "scroll",
            () => {
                if (shareRef.current) {
                    shareRef.current.close();
                }

                if (optionRef.current) {
                    optionRef.current.close();
                }
            },
            true
        );
        return () => {
            window.removeEventListener("scroll", () => {});
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const translateHeader = async()=>{
        if (profile?.id) {
            try{
                setTransLoad(true)
                let curLang = localStorage.getItem('lang');
                const { data } = await http.put(`public/profile/${profile?.id}/translate`,{
                    lang:curLang
                }); 
                if(data.profile || data.socialMed){
                    let user_data = JSON.parse(localStorage.getItem("user_data")); 
                    user_data.profile = {...user_data.profile,...data.profile};
                    const newProfile = {...profile, ...data.profile};
                    handleUpdateTranslate(newProfile, data.socialMed);
                    localStorage.setItem("user_data", JSON.stringify(user_data));
                    toast.success(t('completedTranslate'))
                }else{
                    toast.success(t('beenTranslated'));
                    // handleUpdateTranslate()
                }
                setTransLoad(false)
            }catch(e){
                setTransLoad(false)
                toast.error(t('somethingWentWrong'));
            }
        }
    }

    const hideToast = async()=>{
        if(isYourProfile && Boolean(profile?.onboarding?.social_media) === false && profile.id){
            try{
                await http.put(`public/profiles/tutorialMilestone/${profile.id}`,{
                    column:'social_media'
                });
                setProfile({
                    ...profile,
                    onboarding: {
                        ...(profile.onboarding || {}),
                        social_media: 1
                    }
                });
            }catch(e){
                // toast.error(t('somethingWentWrong'));
                console.log(e)
            }
        }
    }

    useEffect(() => {
        const handleResize = () => {
            if (buttonRef.current) {
                const rect = buttonRef.current.getBoundingClientRect();
                // console.trace(rect.bottom);
                console.trace(rect.left);
                setTooltipPos({
                    top: rect.bottom + "px",
                    left: rect.left + "px"
                });
            }
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className="grid gap-y-4 5sm:flex 5sm:justify-between 5sm:items-center 3md:block items-center">
            <div className={`flex gap-2 ${isSticky ? 'justify-end': 'flex justify-center 5sm:justify-start flex-wrap 5sm:flex-nowrap 3md:justify-end space-x-1.5 profile-right'}`}>
                {(!isYourProfile) &&
                    !_.isEmpty(userData) ?
                    !_.isEmpty(user?.username) && (
                        <div className="flex gap-2">
                            <button
                                className={`p-2 block 5sm:hidden bg-thBg hover:bg-gray flex flex-row items-center 3md:mb-0 3md:py-4 px-3 text-xs 3md:text-sm text-lightBlack font-semibold`}
                                onClick={onClickMessage}
                                style={{ borderRadius: "6px" }}
                            >
                                <BsChatText className="text-lg" />
                                <span className="hidden 5sm:block">{t('message')}</span>
                            </button>
                            <div className="hidden 5sm:block">
                                <Button
                                    buttonName={t("message")}
                                    buttonTextClass="text-xs 3md:text-sm text-lightBlack font-semibold flex items-center"
                                    iconPosition="left"
                                    icon={
                                        <BsChatText className="mr-1.5 3md:mr-3" />
                                    }
                                    disabled={viewPublic}
                                    buttonRadius="6px"
                                    buttonClass="relative py-2.5 3md:mb-0 3md:py-4 px-3.5 bg-thBg hover:bg-gray"
                                    onClick={onClickMessage}
                                />
                            </div>
                            {!_.isEmpty(user?.username) && (
                                <>
                                    {!isYourProfile && (
                                        <button
                                            className="flex flex-row items-center 3md:mb-0 3md:py-3 px-3.5 bg-thBg hover:bg-gray text-xs 3md:text-sm text-lightBlack font-semibold share-own"
                                            onClick={showMoreSocial}
                                            style={{ borderRadius: "6px" }}
                                        >
                                            <BsShare className="mr-1.5 3md:mr-3" />
                                            <span className="">{t('share')}</span>
                                        </button>
                                    )}
                                </>
                            )}
                            {!isSticky && 
                            <button
                                className={`${
                                    follow === 0
                                        ? "bg-thBg hover:bg-gray text-lightBlack"
                                        : "bg-primary hover:bg-darkPrimary text-white"
                                } block 5sm:hidden flex flex-row items-center 3md:mb-0 3md:py-4 px-3 text-xs 3md:text-sm text-lightBlack font-semibold`}
                                onClick={onFollow}
                                disabled={viewPublic}
                                style={{ borderRadius: "6px" }}
                            >
                                {follow === 0 ? (
                                    <BsPersonPlus className=" text-lg" />
                                ) : (
                                    <BsPersonFillCheck className="text-lg" />
                                )}
                                {submitLoading ? (
                                    <LoadingIndicator className="text-blue-500 w-4 h-4 ml-2" />
                                ) : null}
                            </button>
                            }
                            <div className="hidden 5sm:block">
                                <Button
                                    buttonName={`${
                                        follow === 0 ? t("follow") : t("following")
                                    }`}
                                    disabled={viewPublic}
                                    buttonTextClass={`text-xs 3md:text-sm  ${
                                        follow === 0
                                            ? "text-lightBlack"
                                            : "text-white"
                                    } font-semibold flex items-center`}
                                    iconPosition="left"
                                    icon={
                                        follow === 0 ? (
                                            <BsPersonPlus className="mr-1.5 3md:mr-3 text-lg" />
                                        ) : (
                                            <BsPersonFillCheck className="mr-1.5 3md:mr-3 text-lg" />
                                        )
                                    }
                                    buttonRadius="6px"
                                    buttonClass={`relative py-2.5 3md:mb-0 3md:py-4 px-3.5 ${
                                        follow === 0
                                            ? "bg-thBg hover:bg-gray"
                                            : "bg-primary hover:bg-darkPrimary"
                                    } `}
                                    loadingIcon={
                                        submitLoading ? (
                                            <LoadingIndicator className="text-blue-500 w-4 h-4 ml-2" />
                                        ) : null
                                    }
                                    onClick={onFollow}
                                />
                            </div>
                            <Popup
                                ref={optionRef}
                                position="bottom right"
                                open={showMoreOption}
                                onClose={() => setShowMoreOption(false)}
                                arrow={false}
                                contentStyle={{ marginTop: 10, marginLeft: 5 }}
                                trigger={
                                    <button
                                        className="py-0 bg-thBg rounded-md 3md:py-4 3md:px-5 px-3"
                                        onClick={() =>
                                            setShowMoreOption((open) => !open)
                                        }
                                    >
                                        <FaEllipsisH className="p-0 m-0" />
                                    </button>
                                }
                            >
                                <div className="flex flex-col shadow-lg rounded-md bg-white">
                                    <ul className="w-full">
                                         <li>
                                            <Button
                                                disabled={loadingTranslate}
                                                buttonName={
                                                    <div className="flex gap-2 items-center">
                                                        <IoLanguageOutline/>
                                                        <div>{t('translate')}</div>
                                                    </div> 
                                                }
                                                buttonTextClass="text-lg  flex flex-row items-start gap-2"
                                                buttonRadius="6px"
                                                icon={
                                                loadingTranslate ? (
                                                    <LoadingIndicator className="text-primary w-4 h-4" />
                                                ) : null
                                                }
                                                buttonClass="relative px-4 py-2 bg-white hover:bg-gray hover:rounded-b-md justify-start w-full"
                                                onClick={translateHeader}
                                            />
                                        </li>
                                        <li>
                                            <Button
                                                disabled={loadingTranslate}
                                                buttonName={
                                                    <div className="flex gap-2 items-center">
                                                        <FiLink/>
                                                        <div>{t('copyLink')}</div>
                                                    </div> 
                                                }
                                                buttonTextClass="text-lg  flex flex-row items-start gap-2"
                                                buttonRadius="6px"
                                                buttonClass="relative px-4 py-2 bg-white hover:bg-gray hover:rounded-b-md justify-start w-full"
                                                onClick={() => handleCopyClick(state.profileUrl)}
                                            />
                                        </li>
                                        <li className="hover:bg-gray hover:rounded-md">
                                            {
                                                checkRerported ? 
                                                <ToolTip value={t('YouHaveReported')}>
                                                    <button
                                                        onClick={() => {
                                                            onReport(
                                                                {},
                                                                profile,
                                                                "profile"
                                                            );
                                                        }}
                                                        className={`flex flex-row items-center text-lg px-4 py-2 gap-2 ${
                                                            checkRerported &&
                                                            "bg-gray cursor-not-allowed w-full"
                                                        }`}
                                                        disabled={checkRerported}
                                                    >
                                                        <PiWarningOctagonLight className="text-lg" />
                                                        {`${
                                                            checkRerported
                                                                ? t("report")
                                                                : t("reportUser")
                                                        }`}
                                                    </button>
                                                </ToolTip>
                                                :
                                                <button
                                                    onClick={() => {
                                                        onReport(
                                                            {},
                                                            profile,
                                                            "profile"
                                                        );
                                                    }}
                                                    className={`flex flex-row items-center text-lg px-4 py-2 gap-2 ${
                                                        checkRerported &&
                                                        "bg-gray cursor-not-allowed w-full"
                                                    }`}
                                                    disabled={checkRerported}
                                                >
                                                    <PiWarningOctagonLight className="text-lg" />
                                                    {`${
                                                        checkRerported
                                                            ? t("report")
                                                            : t("reportUser")
                                                    }`}
                                                </button>

                                            }
                                        </li>
                                        {isYourProfile && (
                                            <li className="hover:bg-gray hover:rounded-md">
                                                <button
                                                    onClick={() => {
                                                        history.push(
                                                            "/settings",
                                                            {
                                                                profile,
                                                            }
                                                        );
                                                    }}
                                                    className="flex flex-row items-center text-lg px-4 py-2 gap-2"
                                                >
                                                    <FiSettings className="text-lg" />
                                                    {t('settings')}
                                                </button>
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            </Popup>
                        </div>
                    ) 
                    : 
                    /**Show when the user is not login in milestone */
                    !_.isEmpty(user?.username) && 
                    <>
                        {!isYourProfile && (
                            <button
                                className="flex flex-row items-center py-2 3md:mb-0 3md:py-4 px-3.5 bg-thBg hover:bg-gray text-xs 3md:text-sm text-lightBlack font-semibold share-own"
                                onClick={showMoreSocial}
                                style={{ borderRadius: "6px" }}
                            >
                                <BsShare className="mr-1.5 3md:mr-3 text-[17px]" />
                                <span className="">{t('share')}</span>
                            </button>
                        )}
                    </>
                }
                {!_.isEmpty(user?.username) && (
                    <>
                        {isYourProfile && (
                            <>
                            <button
                                className="flex flex-row items-center py-2.5 3md:mb-0 3md:py-4 px-[1.125rem] bg-thBg hover:bg-gray text-xs 3md:text-sm text-lightBlack font-semibold share-own h-[2.25rem] 3md:h-[3.125rem]"
                                onClick={showMoreSocial}
                                style={{ borderRadius: "6px" }}
                            >
                                <BsShare className="mr-1.5 3md:mr-3 text-[17px]"/>
                                {!isSticky &&(
                                    <> &nbsp;&nbsp; <span>{t('share')}</span></>
                                )}
                            </button>
                            <Popup
                                ref={optionRef}
                                position="bottom right"
                                open={showMoreOption}
                                onClose={() => setShowMoreOption(false)}
                                arrow={false}
                                contentStyle={{ marginTop: 10, marginLeft: 5 }}
                                trigger={
                                    <div className="relative">
                                        <button ref={buttonRef}

                                            className="py-0 bg-thBg rounded-md py-2.5 px-3 3md:py-4 3md:px-5"
                                            onClick={() =>
                                                {setShowMoreOption((open) => !open);hideToast()}
                                            }
                                        >
                                            <FaEllipsisH className="p-0 m-0" />
                                        </button>
                                        {
                                            (isYourProfile && profile?.onboarding?.social_media === 0 && profile?.profile_type?.type === "personal" && displayTooltip && socials.length <= 0) &&
                                            <div
                                                style={{
                                                position: "absolute",
                                                top: "60px",
                                                transform: "translateX(-50%)",
                                                zIndex: 999,
                                                boxShadow: "0px 2px 12px 0px rgba(0, 0, 0, 0.12)"
                                                }}
                                                className="w-[320px] md:w-[440px] text-xs md:text-sm uppercase text-center left-[220px] 5sm:left-[160px] md:left-[213px] 5md:left-[220px] 3md:-left-[165px] 2xs:-left-[110px]"
                                            >
                                               <div className="relative w-full rounded-md">
                                                    {/* Arrow */} 
                                                    <div className="absolute z-0 -top-2 w-4 h-4 rotate-45 bg-white shadow-md right-6 md:left-4 md:right-auto 5sm:left-4 5sm:right-auto 5md:right-4 5md:left-auto 2xs:right-4 2xs:left-auto"
                                                        style={{boxShadow: "0px 2px 12px 0px rgba(0, 0, 0, 0.12)"}}
                                                    >
                                                    </div> 
                                                    <div className="bg-white p-3 md:p-2 z-20 relative uppercase text-xs md:text-sm"> 
                                                        Click Here to go to settings and add your socials 
                                                    </div> 
                                                </div>
                                            </div>
                                        }
                                        
                                    </div>
                                }
                            >
                                <div className="flex flex-col shadow-lg rounded-md bg-white">
                                    <ul className="w-full">
                                        <li className="hover:bg-gray hover:rounded-md">
                                            <button
                                                onClick={() => {
                                                    history.push("/settings", {
                                                        profile,
                                                    });
                                                }}
                                                className="flex flex-row items-center text-lg px-4 py-2 gap-2"
                                            >
                                                <FiSettings className="text-lg" />
                                                {t('settings')}
                                            </button>

                                        </li>
                                        <li>
                                            <Button
                                                disabled={loadingTranslate}
                                                buttonName={
                                                    <div className="flex gap-2 items-center">
                                                        <FiLink/>
                                                        <div>{t('copyLink')}</div>
                                                    </div> 
                                                }
                                                buttonTextClass="text-lg  flex flex-row items-start gap-2"
                                                buttonRadius="6px"
                                                buttonClass="relative px-4 py-2 bg-white hover:bg-gray hover:rounded-b-md justify-start w-full"
                                                onClick={() => handleCopyClick(state.profileUrl)}
                                            />
                                        </li>
                                    </ul>
                                </div>
                            </Popup>
                            </>
                        )}
                    </>
                )}
                {hasPermission && !_.isEmpty(user?.username) && !viewPublic && (//remove the pop-up conflict for same user with different profile open on first load
                    <>
                        {/* {!isYourProfile && (
                            <button
                                className="flex flex-row items-center 3md:mb-0 3md:py-4 px-3 bg-thBg hover:bg-gray text-xs 3md:text-sm text-lightBlack font-semibold"
                                onClick={showMoreSocial}
                                style={{ borderRadius: "6px" }}
                            >
                                <BsShare className="3md:mr-3" />
                                <span className="hidden 3md:block">Share</span>
                            </button>
                        )} */} 
                        
                        {/* {isYourProfile && (
                            <Button
                                buttonTextClass="text-xs 3md:text-sm text-lightBlack font-semibold flex items-center justify-center"
                                iconPosition="left"
                                icon={<FaEllipsisH className="text-base" />}
                                buttonRadius="6px"
                                buttonClass="relative py-2.5 block 3md:hidden px-3 bg-thBg hover:bg-gray"
                                onClick={() =>
                                    history.push("/settings", { profile })
                                }
                            />
                        )} */}
                    </>
                )}
            </div>
            {showSocialMedia && (
                <div className="3md:mt-10 relative flex justify-center 5sm:justify-end w-full">
                    <div className="flex justify-center 3md:justify-end items-center gap-1.5 3md:gap-2.5 flex-wrap">
                        {socials.slice(0, 5).map((obj, index) => (
                            <Link
                                className="group/link"
                                to={{
                                    pathname: obj.link,
                                }}
                                target="_blank"
                                key={index}
                            >
                                <ToolTip value={obj.link}>
                                    <p className="w-9 h-9 3md:w-12 3md:h-13 bg-bGray rounded-md group-hover/link:bg-gray truncate flex justify-center items-center">
                                        {
                                        obj?.fav_icon ? (
                                            <p
                                                className={`bg-trasnparent rounded-md truncate flex justify-center w-[100%]`}
                                            >
                                                <Favicon domain={obj.link} hasFavIconFile={obj.fav_icon || null}/>
                                            </p>
                                        ) : (
                                            <p
                                                className={`bg-bGray rounded-md truncate group-hover/link:bg-gray flex justify-center`}
                                            >
                                                <Favicon domain={obj.link}/>
                                            </p>
                                        )}
                                    </p>
                                </ToolTip>
                            </Link>
                        ))}
                        {socials.length > 5 && (
                            <StyledPopup
                            ref={optionRef}
                            position="bottom right"
                            open={open}
                            onClose={() => setOpen(false)}
                            arrow={false}
                            // contentStyle={{ marginTop: 20, marginLeft: 80 }}
                            trigger={
                                <div className="flex items-center">
                                    <button
                                        className={`p-3 5sm:p-2 2md:p-3.5 bg-${
                                            open ? "activeGray" : "bGray"
                                        } rounded-md`}
                                        onClick={() => setOpen((prev) => !prev)}
                                    >
                                        <FaAngleDown className="text-xs 5sm:text-xl" />
                                    </button>
                                </div>
                            }
                        > 
                                {/* {open && ( */}
                                    <div className="w-[250px] flex flex-col top-15 social-box p-2.5">
                                        <div className="w-full grid grid-cols-4 gap-2.5">
                                            {socials
                                                .slice(5, socials.length)
                                                .map((obj, index) => (
                                                    <Link
                                                        className="group/morelink flex justify-center items-center bg-bGray"
                                                        to={{
                                                            pathname: obj.link,
                                                        }}
                                                        target="_blank"
                                                        key={index}
                                                    >
                                                        <div className="relative group flex justify-center">
                                                            <p className="w-7.5 h-7.5 3md:w-12 3md:h-13 bg-bGray rounded-md group-hover/link:bg-gray truncate flex justify-center items-center shadow-md">
                                                                {
                                                                // Object.keys(
                                                                //     social_icons
                                                                // ).includes(
                                                                //     obj.type
                                                                // ) ? (
                                                                //     social_icons[
                                                                //         obj.type
                                                                //     ]
                                                                // ) :
                                                                obj?.fav_icon ? (
                                                                    <p
                                                                        className={`bg-trasnparent rounded-md truncate flex justify-center w-[100%]`}
                                                                    >
                                                                        <Favicon domain={obj.link} hasFavIconFile={obj?.fav_icon || null}/>
                                                                    </p>
                                                                )
                                                                :
                                                                (
                                                                    <p
                                                                        className={`bg-bGray rounded-md truncate group-hover/link:bg-gray flex justify-center`}
                                                                    >
                                                                        <Favicon domain={obj.link} hasFavIconFile={obj?.fav_icon || null}/>
                                                                    </p>
                                                                )}
                                                            </p>
                                                            <div class="absolute opacity-0 group-hover:opacity-100 text-center transition-opacity duration-300 ease-in-out -top-9">
                                                                <div className="relative flex justify-center ">
                                                                    <div className="z-20 text-[10px] bg-gray p-1 px-2 rounded-md  min-w-18">
                                                                        {
                                                                            obj.link
                                                                        }
                                                                    </div>
                                                                    <div className="absolute z-0 top-[18px] w-2 h-2 transform rotate-45 -transalte-x-1/2 bg-gray"></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                ))}
                                        </div>
                                    </div>
                               {/** )} */}
                            </StyledPopup>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}
const StyledPopup = styled(Popup)`
  &-content{
    margin-top: 15px;
    margin-left:21px;
  }

  @media (max-width: 429px) {
    &-content{
      margin-left:9px;
    }
  }
`;